export * from '@primeuix/themes/material/dataview';
export { default } from '@primeuix/themes/material/dataview';
